import getEnv from '@/utils/env';
import { EnvironmentTypes } from '@/types/environmentTypes';
import axios from 'axios';
import { MimeTypes } from '@/types/general';

export function downloadFile(data: any, fileName: string, fileType: string, isOpeningWindow = false) {
  const blob = new Blob([data], fileType ? { type: fileType } : undefined);
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
  if (isOpeningWindow) {
    window.open(link.href, '_blank');
  }
  URL.revokeObjectURL(link.href);
}

export async function fileToBase64(file: File, checkLength = false): Promise<string | null> {
  try {
    const b64 = (await getBase64String(file)) as string;
    /**
     * The expected format is `byte` which is a base64 encoded string like `U3dhZ2dlciByb2Nrcw==
     * The readAsDataURL returns the file base64 encoded but prefixed with info about the file
     * like: `data:application/pdf;base64,JVBERi0xLjQKJZOMi54...`
     * For this reason we split it by "," and only take the last part.
     */
    const b64Raw = b64.split(',')[1];
    /**
     * The following code can be used if we decide to check for file size before upload
     * 5'222'428 characters seems to be around the maximum allowed length of
     * a base64 encoded payload.
     */
    if (checkLength && b64Raw.length > 5_222_428) {
      console.error('Payload is too large.');
      return null;
    }
    return b64Raw;
  } catch (error) {
    console.error('An error occurred while extracting raw base 64 string:', error);
    return null;
  }
}

export function getBase64String(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export async function getFileGW(path: string) {
  const response = await axios.get(`${getEnv(EnvironmentTypes.VITE_APP_GW_HOST)}/public/${path}`);
  return response.data;
}

export function mimeTypeFromFileType(fileType: string): MimeTypes {
  switch (fileType) {
    case 'pdf':
      return MimeTypes.PDF;
    case 'png':
      return MimeTypes.PNG;
    case 'jpg':
    case 'jpeg':
      return MimeTypes.JPEG;
    default:
      return MimeTypes.AllImages;
  }
}

export function fileTypeFromMimeType(mimeType: MimeTypes | string): string {
  switch (mimeType) {
    case MimeTypes.PDF:
      return 'pdf';
    case MimeTypes.PNG:
      return 'png';
    case MimeTypes.JPEG:
      return 'jpeg';
    default:
      // FIXME: this is not safe or good, we should probably fail here
      return 'jpg';
  }
}
